import { AwardType, MediaObjectUrl } from '@kudos/http-client'
import { createContext } from 'react'

export type AwardsRouteContextType = {
  awardTypesData: AwardType[]
  isLoading: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  hasNextPage: boolean
  delegatorId?: string
  delegatorFirstName?: string
  delegatorLastName?: string
  delegatorAvatarUrls?: MediaObjectUrl | null
}

export const AwardsRouteContext = createContext<AwardsRouteContextType>(
  {} as AwardsRouteContextType,
)
